import { Tooltip } from '@mui/material';
import { ValueFormatterParams } from 'ag-grid-community';
import { PartnerSearchResponse } from 'pco-product-service-internal-consumer';

/**
 * Remove all space and special characters from a string
 * @param inputString the string to transform
 */
export const removeWhitespaceSpecialCharacters = (inputString: string) => {
  return inputString.replace(/[^A-Z0-9]/gi, '');
};

export const addLeadingZeros = (inputString: string, length: number) => {
  if (inputString.length >= length) {
    return inputString.slice(0, length);
  }
  let newValue = '';
  for (let i = 0; i < length - inputString.length; i++) {
    newValue = newValue.concat('0');
  }
  newValue = newValue.concat(inputString);
  return newValue;
};

/**
 * Convert a snake-case ENUM value (e.g. "TAX_RESIDENCE, DOMICILE") to sentence case ("Tax residence, Domicile")
 * @param enumString the enum to convert
 */
export function formatEnum(enumString: string): string {
  return enumString
    ? enumString.charAt(0) +
        enumString
          .slice(1)
          .replace(/_/g, ' ')
          .toLowerCase()
          .replace(/,\s*([a-z])/g, function (d, e) {
            return ', ' + e.toUpperCase();
          })
    : enumString;
}

/**
 * Convert a number to a more human readable format
 * @param number the number to convert
 */
export function formatNumber(number: number) {
  return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'");
}

export const longTextFormatter = (params: ValueFormatterParams | { value: string | undefined }) => {
  if (!params.value) {
    return '';
  }
  return (
    <Tooltip title={params.value}>
      <span
        style={{
          display: ' inline-block',
          marginTop: '0',
          overflow: 'hidden',
          maxWidth: '10em',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >
        {params.value}
      </span>
    </Tooltip>
  );
};

export const getPartnerName = (serviceRole: PartnerSearchResponse | undefined) => {
  if (!serviceRole) {
    return '';
  }

  if (serviceRole?.fullName) {
    return serviceRole?.fullName;
  }

  return '';
};

/**
 * This function takes an all caps string with ever word seperated by '_'
 * such as 'THIS_IS_A_STATUS' and returns 'This is a status'
 *
 * @export
 * @param {*} str
 * @return {*}
 */
export function humanReadableString(str: string | undefined | null) {
  const arr = str?.split(' ');
  const newArr: string[] = [];

  if (!arr) return '';

  for (let i = 0; i < arr.length; i++) {
    const word: string = arr[i].toLowerCase().replace(/_/g, ' ');
    newArr.push(word[0].toUpperCase() + word.slice(1));
  }
  return newArr.join(' ');
}
